
import { CotizadorComponent } from './cotizador.component';
import { MantenimientoComponent } from '../../mantenimiento/mantenimiento.component';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: 'mantenimiento',
    component: MantenimientoComponent
  },
  {
    path: '',
    component: CotizadorComponent // Se carga dentro de HomeComponent
  },
  {
    path: 'art',
    loadChildren: () => import('./art/art.module').then(m => m.ArtModule)
  },
  {
    path: 'praxis',
    loadChildren: () => import('./praxis/praxis.module').then(m => m.PraxisModule)
  },
  {
    path: 'prepaga',
    loadChildren: () => import('./prepaga/prepaga.module').then(m => m.PrepagaModule)
  },
  {
    path: 'automotor',
    loadChildren: () => import('./automotor/automotor.module').then(m => m.AutomotorModule)
  },
  {
    path: 'motovehiculo',
    loadChildren: () => import('./automotor/automotor.module').then(m => m.AutomotorModule)
  },
  {
    path: ':uuid', // Ruta dinámica debe ir al final
    component: CotizadorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CotizadorRoutingModule {

}
